import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

function AuthCallback({ setUser }) {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const handleGoogleCallback = () => {
      try {
        const token = searchParams.get('token');
        const userString = searchParams.get('user');
        const error = searchParams.get('error');

        if (error) {
          console.error('Authentication error:', error);
          navigate('/login?error=auth_failed', { replace: true });
          return;
        }

        if (!token || !userString) {
          console.error('Missing token or user data');
          navigate('/login?error=missing_data', { replace: true });
          return;
        }

        const userData = JSON.parse(decodeURIComponent(userString));
        
        // Store user data temporarily
        localStorage.setItem('chatapp_user', JSON.stringify(userData));
        
        // Check if profile setup is complete
        if (userData.profileSetupComplete === false) {
          // Redirect to profile setup
          navigate('/profile-setup', { 
            replace: true, 
            state: { user: userData } 
          });
        } else {
          // Profile is complete, set user and go to home
          setUser(userData);
          navigate('/', { replace: true });
        }
      } catch (error) {
        console.error('Error processing authentication callback:', error);
        navigate('/login?error=processing_failed', { replace: true });
      }
    };

    handleGoogleCallback();
  }, [searchParams, navigate, setUser]);

  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100vh',
      fontFamily: 'Arial, sans-serif'
    }}>
      <div>
        <h2>Completing authentication...</h2>
        <p>Please wait while we log you in.</p>
      </div>
    </div>
  );
}

export default AuthCallback;
